import Login from "../components/pages/Login";
import { IRoute, RouteBuilder } from "../models/RouteModels";
const routes: IRoute[] = [
  RouteBuilder.getBuilder(1).setPath("/login").setComponent(Login).build(),
];

export default routes;
